import * as z from "zod";

export const contactFormSchema = z.object({
  name: z
    .string()
    .min(2, {
      message: "Name must be at least 2 characters.",
    })
    .max(100, {
      message: "Name must be less than 100 characters.",
    }),
  email: z
    .string()
    .email({
      message: "Please enter a valid email address.",
    })
    .max(255, {
      message: "Email must be less than 255 characters.",
    }),
  message: z
    .string()
    .min(10, {
      message: "Message must be at least 10 characters.",
    })
    .max(2000, {
      message: "Message must be less than 2000 characters.",
    }),
  phone: z
    .string()
    .max(20, { message: "Phone number must be less than 20 characters." })
    .regex(/^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?(\d{3})[-.\s]?(\d{4})$/, {
      message: "Please enter a valid phone number.",
    })
    .optional(),
  company: z
    .string()
    .max(100, { message: "Company name must be less than 100 characters." })
    .optional(),
  attachment: z
    .object({
      id: z.string(),
      name: z.string(),
      url: z.string(),
      type: z.string(),
      size: z.string(),
      dateAdded: z.date(),
    })
    .optional(),
});

export type ContactFormData = z.infer<typeof contactFormSchema>;
